enum FocusType {
	NONE,
	EVENT,
	TIME,
	FIRST_EVENT,
	CUSTOM_SELECTOR,
}

export default FocusType;
